exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.detail-section{margin-bottom:2rem\n}\n.is-indented{margin-left:2rem\n}\n.is-indented .detail{margin-left:0\n}\n", ""]);




//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3095fffa","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"includePaths":["/home/runner/work/parks-rec-finder/parks-rec-finder/node_modules/foundation-sites/scss"]}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"/home/runner/work/parks-rec-finder/parks-rec-finder/src/style/_variables.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DetailSection.vue
// module id = 716
// module chunks = 0